import React, { useEffect, useState } from 'react';
import * as S from './styles';
import {
  Topbar,
  Navbar,
  DashboardFooter,
  DashboardItem,
} from '../../components';

import { buildingItemCodes, dashboardItems } from '../../utils/mocks/dashboard';
import { TermsModal } from '../../components/TermsModal/TermsModal';
import { identityProvider } from '../../services/api';
import useDealer from '../../hooks/useDealer/useDealer';
import { useStorage } from '../../hooks';
import { toast } from 'react-toastify';

interface DashboardItem {
  title: string;
  icon: string;
  path: string;
  isActive: boolean;
  code: string;
  iconReact?: boolean;
}

export const Dashboard: React.FC = () => {
  const [permissions, setPermissions] = useState<DashboardItem[] | null>(null);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [termsModalContent, setContentModal] = useState<{
    data: any;
    errors: any;
  } | null>(null);

  const { fetchTermsOfUse } = useDealer();
  const { getItemOnStorage, removeItemOnStorage } = useStorage();

  useEffect(() => {
    const user: any = getItemOnStorage('currentUser');

    if (user) {
      const userData = JSON.parse(user);
      const userDataMapped = mapUserAccess(userData);
      setPermissions(userDataMapped);

      if (userData.aceitouTermosUso !== 'True') {
        setIsTermsModalOpen(true);
        fetchTermsOfUse()
          .then(response => {
            setContentModal(response.data);
          })
          .catch(error => {
            console.error('Erro ao buscar termos de uso:', error);
            setContentModal({ data: null, errors: error });
          });
      }
    }
  }, []);

  const mapUserAccess = (accessData: any) => {
    const userAccessItems = dashboardItems.map(elm => {
      if (accessData.roles.includes(elm.code)) {
        return {
          ...elm,
          isActive: !buildingItemCodes.includes(elm.code),
        };
      }
      return elm;
    });

    return userAccessItems;
  };

  const handleAcceptTerms = async () => {
    try {
      const token = getItemOnStorage('token');
      const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
      const response = await identityProvider.post(
        '/api/aceito-termos-uso',
        {
          representanteId: user.userId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response) {
        const updatedUser = { ...user, aceitouTermosUso: 'True' };
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
        toast.success('Termos aceito com sucesso.');
        setIsTermsModalOpen(false);
      } else {
        console.error('Failed to accept terms:', response);
        toast.error(
          'Ocorreu um erro ao aceitar os termos. Por favor, tente novamente.',
        );
      }
    } catch (error) {
      console.error('Error accepting terms:', error);
      toast.error(
        'Ocorreu um erro de rede ao aceitar os termos. Por favor, verifique sua conexão.',
      );
    }
  };

  const handleDeclineTerms = () => {
    removeItemOnStorage('currentUser');
    window.location.href = '/login';
  };

  return (
    <S.Container>
      <Topbar />
      <Navbar />
      <S.Content>
        <S.Title>Meu Painel</S.Title>
        <S.ContentContainer className="container-title">
          {permissions &&
            permissions.map((item, index) => {
              return (
                <DashboardItem
                  isActive={item.isActive}
                  title={item.title}
                  icon={item.icon}
                  iconReact={item.iconReact}
                  path={item.path}
                  key={index}
                />
              );
            })}
        </S.ContentContainer>
      </S.Content>
      <DashboardFooter />
      <TermsModal
        isOpen={isTermsModalOpen}
        content={termsModalContent}
        onAccept={handleAcceptTerms}
        onDecline={handleDeclineTerms}
      />
    </S.Container>
  );
};
